import { InjectionToken } from '@angular/core';

export const TRANSFER_BALANCE_DATA = new InjectionToken<{}>('TRANSFER_BALANCE_DATA');
export const DRAWER_DATA = new InjectionToken<unknown>('DRAWER_DATA');
